import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {useProductLineItem} from "../hooks/useProductLineItem.ts";
import {ProductLineItem} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('productId is required')
    }

    const {
        createRecord,
    } = useProductLineItem(productId);

    return (
        <FormDrawer
            record={{
                id: '',
                productId: productId,
                productFeatureId: '',
                position: 0,
                created: new Date().toISOString(),
            } as ProductLineItem}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
